module.exports = "/images/mk.svg?05d91033d44452a0560a563d6d967ac7";